module.exports = __webpack_public_path__ + "b03fd3cee071308ba31a181933b21f1e.svg";